"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AvatarGroup = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _designTokens = require("@smartsheet/design-tokens");
var _lodestarUtils = require("@smartsheet/lodestar-utils");
var _react = _interopRequireWildcard(require("react"));
var _i18n = require("../../../i18n/i18n");
var _contactcard = require("../../contactcard");
var _visuallyhidden = require("../../visuallyhidden");
var _AvatarGroupAvatarsRoot = require("../styled/AvatarGroupAvatarsRoot");
var _getAvatarData = require("../util/getAvatarData");
var _AvatarGroupProvider = require("./AvatarGroupProvider");
var _AvatarWithFlyout = require("./AvatarWithFlyout");
var _ClipPathDefs = require("./ClipPathDefs");
const AvatarGroup = /*#__PURE__*/(0, _react.forwardRef)((_ref, parentRef) => {
  let {
    className,
    clientId,
    maxUsersUntilOverflow = 4,
    size = 32,
    users,
    locale = "en",
    requireFlyoutKeyboardToggle = true,
    portalProps,
    flyoutHeader,
    ...rest
  } = _ref;
  const localRef = (0, _react.useRef)(null);
  const ref = (0, _lodestarUtils.useForkRef)(parentRef, localRef);
  const thisGroupId = (0, _react.useMemo)(() => (0, _lodestarUtils.genId)("ag"), []);
  const {
    visibleUsers,
    overflowUsers
  } = (0, _getAvatarData.getAvatarData)(users,
  // We don't want this to go below 1 Avatar.
  Math.max(1, maxUsersUntilOverflow));
  const visibleUsersFlyouts = (0, _react.useMemo)(() => {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, visibleUsers.map(user => {
      return /*#__PURE__*/_react.default.createElement(_AvatarWithFlyout.AvatarWithFlyout, {
        key: user.email,
        id: `${user.email}-${thisGroupId}`,
        size: size,
        email: user.email,
        initials: user.initials,
        "aria-label": user.name ? `${user.name}, ${user.email}` : user.email,
        imgSrc: user.profileImageUrl,
        showRing: user.showRing || false,
        flyoutContents: /*#__PURE__*/_react.default.createElement(_contactcard.ContactCard, {
          mode: "condensed",
          avatarProps: {
            src: user.profileImageUrl,
            initials: user.initials,
            email: user.email
          },
          cardHeader: flyoutHeader
        }, /*#__PURE__*/_react.default.createElement(_contactcard.ContactCardName, null, user.name || user.email), user.name && /*#__PURE__*/_react.default.createElement(_contactcard.ContactCardDetailItem, null, user.email)),
        portalProps: portalProps
      });
    }));
  }, [visibleUsers, portalProps, size, thisGroupId, flyoutHeader]);
  return /*#__PURE__*/_react.default.createElement(_i18n.I18nContextProvider, {
    locale: locale
  }, /*#__PURE__*/_react.default.createElement(_i18n.I18NContextConsumer, null, _ref2 => {
    let {
      i18n
    } = _ref2;
    return /*#__PURE__*/_react.default.createElement(_AvatarGroupProvider.AvatarGroupProvider, {
      thisGroupId: thisGroupId,
      visibleUsers: visibleUsers,
      overflowUsers: overflowUsers
    }, /*#__PURE__*/_react.default.createElement(_AvatarGroupAvatarsRoot.AvatarGroupAvatarsRoot, (0, _extends2.default)({}, rest, {
      leftClipModeId: (0, _ClipPathDefs.getClipId)(thisGroupId, "left"),
      bothClipModeId: (0, _ClipPathDefs.getClipId)(thisGroupId, "both"),
      rightClipModeId: (0, _ClipPathDefs.getClipId)(thisGroupId, "right"),
      "data-client-id": clientId,
      className: className,
      ref: ref
    }), visibleUsersFlyouts, overflowUsers.length > 0 && /*#__PURE__*/_react.default.createElement(_AvatarWithFlyout.AvatarWithFlyout, {
      id: `${_AvatarGroupProvider.OVERFLOW_ID_PREFIX}${thisGroupId}`,
      size: size,
      color: {
        backgroundColor: _designTokens.ursaColors.neutral75,
        textColor: _designTokens.ursaColors.neutral800
      },
      initials: `+${Math.min(overflowUsers.length, 99)}` /* 99 is the max so that we don't display more than 3 chars */,
      imgSrc: undefined,
      "aria-label": i18n._( /*i18n*/{
        comment: "This avatar depicts the number of extra users contained in a flyout that opens on hover/click",
        id: `Click to see {number} more users`,
        values: {
          number: overflowUsers.length
        }
      }),
      showRing: false,
      requireKeyboardToggle: requireFlyoutKeyboardToggle,
      flyoutContents: overflowUsers.map((user, idx) => /*#__PURE__*/_react.default.createElement(_contactcard.ContactCard, {
        mode: "condensed",
        key: user.email,
        avatarProps: {
          src: user.profileImageUrl,
          initials: user.initials,
          email: user.email
        },
        cardHeader: idx === 0 && flyoutHeader
      }, /*#__PURE__*/_react.default.createElement(_contactcard.ContactCardName, null, user.name || user.email), user.name && /*#__PURE__*/_react.default.createElement(_contactcard.ContactCardDetailItem, null, user.email))),
      portalProps: portalProps
    }), /*#__PURE__*/_react.default.createElement(_visuallyhidden.VisuallyHidden, {
      "aria-hidden": true
    }, /*#__PURE__*/_react.default.createElement(_ClipPathDefs.ClipPathDefs, {
      id: thisGroupId,
      height: size
    }))));
  }));
});
exports.AvatarGroup = AvatarGroup;
AvatarGroup.displayName = "AvatarGroup";
//# sourceMappingURL=AvatarGroup.js.map